module.exports = __webpack_public_path__ + "rigo-baby.jpg";